module.exports = __webpack_public_path__ + "media/images/spinners/ring-resize-26a3bb20d17c722a4edf6b2112b77eb0.svg";